import { createSlice } from '@reduxjs/toolkit';
import { postHubspotData } from './hubspotThunks';

const hubspotSlice = createSlice({
  name: 'hubspot',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postHubspotData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postHubspotData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(postHubspotData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default hubspotSlice.reducer;